<script>
import axios from 'axios'
import $ from 'jquery'

const STORAGE_KEY = 'openweb-menu'
export default {
  props: {
    activites: {
      type: Array,
      default() {
        return []
      }
    },
    firstCode: {
      type: String,
      default: ''
    },
    currentCode: {
      type: String,
      default: ''
    },
    xmlDataVersion: {
      type: Number,
      default: 0
    },
    niveauMax: {
      type: Number,
      required: true,
      validator(value) {
        return value >= 0
      }
    },
    cacheKey: {
      type: String,
      default: ''
    },
    plvAffichage: {
      type: String,
      default: ''
    },
    plvOuverture: {
      type: String,
      default: ''
    },
    plvCasse: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      menus: null,
      activite: null,
      timeout: null,
      fetching: false
    }
  },
  async created() {
    this.clearLocalStorage()
    this.activites.forEach( activite => this.getSubMenu(activite))
    let activiteCode = (this.currentCode !== '') ? this.currentCode : this.firstCode
    this.getSubMenu(activiteCode)
  },
  methods: {
    async clearLocalStorage() {
      let clientVersion = Number(window.localStorage.getItem(STORAGE_KEY + '_version'))
      let cacheKey = String(window.localStorage.getItem(STORAGE_KEY + '_cacheKey'))
      if( clientVersion !== this.xmlDataVersion || cacheKey !== this.cacheKey ) {
        let regexFilter = new RegExp('^'+STORAGE_KEY)
        Object.keys(window.localStorage).forEach(function (key) {
          if ((regexFilter.test(key))) {
            localStorage.removeItem(key)
          }
        })
        window.localStorage.setItem(STORAGE_KEY + '_version', this.xmlDataVersion)
        window.localStorage.setItem(STORAGE_KEY + '_cacheKey', this.cacheKey)
      }
    },
    getLibelleCasse(libelle, casse) {
      if (casse === 'maj') {
        return libelle.toUpperCase()
      } else if (casse === 'min') {
        return libelle.charAt(0).toUpperCase() + libelle.slice(1).toLowerCase()
      } else {
        return libelle
      }
    },
    loadSubMenu(event) {
      clearTimeout(this.timeout)
      let eventActivite = event.currentTarget.id.replace('js_', '')
      this.timeout = setTimeout(() => {
        this.getSubMenu(eventActivite)
      }, 50)
    },
    async getSubMenu(eventActivite) {
      if (this.activite != eventActivite) {
        this.fetching = true
        this.menus = null
        this.activite = eventActivite
        let menus = await this.fetch()
        if (menus.activite === this.activite) {
          this.menus = menus
          this.fetching = false
        }
      }
    },
    async fetch() {
      const menus = JSON.parse(window.localStorage.getItem(STORAGE_KEY + this.activite) || '[]')
      let activiteCode = (this.activite != '') ? this.activite : this.firstCode
      if (menus.length === 0) {
        const response = await axios.get('/submenu/' + activiteCode).catch(e => {
          throw new Error('error getting menu', e)
        })
        this.save(response.data)
        return response.data
      } else {
        return menus
      }
    },
    save(menus) {
      window.localStorage.setItem(STORAGE_KEY + menus.activite, JSON.stringify(menus))
    },
    toggle: function (plvAffichage) {
      if (plvAffichage === 'VT') {
        $('.desktopView #menuPLV.menuVT #show_catalogMenu').removeClass('navSiteHover')
        $('.desktopView #menuPLV.menuVT #catalogMenu').hide()
      }
      else if (plvAffichage === 'HZ') {
        $('.desktopView #menuPLV.menuHZ #catalogMenu .menu').removeClass('menuHover')
        $('.desktopView #menuPLV.menuHZ #catalogMenu .menuProduit_activites').hide()
      }
    }
  }
}
</script>
